<div class="row fixed-bottom">
  @for (notification of notifications; track notification) {
    <div class="col-lg-6 col-md-6 col-sm-12">
      <alert class="mt-3 mr-3 ml-3 shadow-lg" [dismissible]="true" [type]="notification.type" (onClosed)="close(notification)">
        @if (notification.message) {
          <div>
            {{ notification.message }}
          </div>
        }
        @if (isErrorDescriptor(notification)) {
          <div>
            An error occurred. Please contact the administrator with error id: <b>{{ notification.errorDescriptor?.id }}</b
            >.
            <a (click)="toggleDetials($event, notification)" class="alert-danger">
              @if (!notification.showDetails) {
                <span>[show details]</span>
              }
              @if (notification.showDetails) {
                <span>[hide details]</span>
              }
            </a>
            @if (notification.showDetails) {
              <div class="data-block">
                <div class="data-row">
                  <span class="data-label">ID: </span>
                  <span class="value">{{ notification.errorDescriptor?.id | toDashesIfEmpty }}</span>
                </div>
                <div class="data-row">
                  <span class="data-label">Code: </span>
                  <span class="value">{{ notification.errorDescriptor?.errorCode | toDashesIfEmpty }}</span>
                </div>
                <div class="data-row">
                  <span class="data-label">Status: </span>
                  <span class="value">{{ notification.errorDescriptor?.status | toDashesIfEmpty }}</span>
                </div>
                <div class="data-row">
                  <span class="data-label">Timestamp: </span>
                  <span class="value">{{ notification.errorDescriptor?.timestamp | utcDateFormat | toDashesIfEmpty }}</span>
                </div>
                <div class="data-row">
                  <span class="data-label">Message: </span>
                  <span class="value"
                    ><b>{{ notification.errorDescriptor?.error | toDashesIfEmpty }}</b>
                  </span>
                </div>
              </div>
            }
          </div>
        }
      </alert>
    </div>
  }
</div>
